import axiosInstance from "./AxiosInstance";
 
export function getDiscount() {
    return axiosInstance.get(`discount/getall`);
}